import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import common from './modules/common.js'
import user from './modules/user.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: { common, user },
  /* 数据持久化配置 */
  plugins: [
    // 方法一 存储所有的state状态
    // createPersistedState({
    //   storage: window.sessionStorage, // 存储方式：localStorage、sessionStorage、cookies
    //   key: 'store', // 存储的的key值
    //   reducer(state) {
    //     // 存储了state中所有的数据
    //     return { ...state }
    //   }
    // })
    // 方法二 存储指定的状态
    createPersistedState({
      storage: window.sessionStorage,
      key: 'common',
      // 只持久化存储scenic模块的状态
      paths: ['common']
    })
  ]
})
